import { ComponentProps } from 'react';

import clsx from 'clsx';

export function Fieldset(props: ComponentProps<'fieldset'>) {
  const { className = '', ...rest } = props;

  return <fieldset className={clsx('grid w-full items-center gap-3', className)} {...rest} />;
}
